import PatientHistoryTimeline from "@/components/patients/PatientHistoryTimeline";
import type { PatientDayEventType } from "@/components/calendar/types/patient-day-events";

interface MobilePetHistoryTabProps {
  petId: string;
  clinicId: string | null;
  includeGrooming: boolean;
  initialOpenEvent?: { type: PatientDayEventType; sourceId: string } | undefined;
}

export function MobilePetHistoryTab({
  petId,
  clinicId,
  includeGrooming,
  initialOpenEvent,
}: MobilePetHistoryTabProps) {
  return (
    <PatientHistoryTimeline
      petId={petId}
      clinicId={clinicId}
      includeGrooming={includeGrooming}
      timeScope="past"
      hideFutureDetails
      initialOpenEvent={initialOpenEvent}
    />
  );
}
